import { render, staticRenderFns } from "./OnboardingLayout.vue?vue&type=template&id=4e0ddd01&scoped=true&"
import script from "./OnboardingLayout.vue?vue&type=script&lang=ts&"
export * from "./OnboardingLayout.vue?vue&type=script&lang=ts&"
import style0 from "./OnboardingLayout.vue?vue&type=style&index=0&id=4e0ddd01&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0ddd01",
  null
  
)

export default component.exports